// const API_BASE = window.vehicleConfig.apiBase;
// const API_KEY = window.vehicleConfig.apiKey;

let currentVehicle = null;
let currentCarSize = null;

document.addEventListener("DOMContentLoaded", initCollection);

document.addEventListener("vehicle:selected", function(e){

    applyVehicle(e.detail);

});
const changeBtn = document.getElementById("changeVehicleBtn");

if(changeBtn){

    changeBtn.addEventListener("click",function(){

        console.log("Change Vehicle Clicked");

        openCarPopup();

    });

}

document.addEventListener("DOMContentLoaded", () => {
    buildFilters();
    bindFilters();
});

async function initCollection(){

    currentVehicle = getSavedCar();

    if(!currentVehicle){

        openCarPopup();

        return;

    }

    await applyVehicle(currentVehicle);
    console.log('bindAddButtons')
    bindAddButtons();
    console.log('bindAddButtons-done')
}

function getCarSize(brand, model){

    if(
        CAR_MODELS[brand] &&
        CAR_MODELS[brand][model]
    ){

        return CAR_MODELS[brand][model];

    }

    return "Medium";

}

async function applyVehicle(car){

    currentVehicle = car;

    currentCarSize = getCarSize(
        car.brand,
        car.model
    );

    updateVehicleBar();
    console.log("Current Car Size :", currentCarSize);

    updatePrices();

    await checkCartServices();

}

function updateVehicleBar(){

    document.getElementById("selectedVehicleText").innerHTML =
        `${currentVehicle.brand} > ${currentVehicle.model} > ${currentCarSize}`;

    setVehicleHiddenFields(
        currentVehicle.brand,
        currentVehicle.model,
        currentCarSize
    );

}
function setVehicleHiddenFields(brand, model, size) {

    document.querySelectorAll(".service-card form").forEach(form => {

        const brandInput = form.querySelector(".car-brand-input");
        const modelInput = form.querySelector(".car-model-input");
        const sizeInput  = form.querySelector(".car-size-input");

        if (brandInput) brandInput.value = brand;
        if (modelInput) modelInput.value = model;
        if (sizeInput)  sizeInput.value = size;

    });

}

function updatePrices(){

    document.querySelectorAll(".service-card").forEach(function(card){

        let price = 0;

        if(currentCarSize.toLowerCase()=="small"){

            price = card.dataset.smallPrice;

        }

        else if(currentCarSize.toLowerCase()=="medium"){

            price = card.dataset.mediumPrice;

        }

        else{

            price = card.dataset.largePrice;

        }

        card.querySelector(".dynamic-price").innerHTML =

        (price/100).toFixed(2);

    });

}
document.addEventListener("cart:changed", async function () {

    await checkCartServices();
    await refreshCartDrawer();

});
function bindAddButtons(){

    document.addEventListener("click",function(e){

        const btn = e.target.closest(".add-service-btn");
         console.log("Add Service Clicked");

        if(!btn) return;

        e.preventDefault();

        addService(btn);

    });

}


function addService(button){

    if(!currentCarSize){

        alert("Please select your vehicle.");
        openCarPopup();
        return;

    }

    if(button.disabled) return;

    const card = button.closest(".service-card");

    let variantId = "";

    if(currentCarSize.toLowerCase()=="small"){

        variantId = card.dataset.smallId;

    }
    else if(currentCarSize.toLowerCase()=="medium"){

        variantId = card.dataset.mediumId;

    }
    else{

        variantId = card.dataset.largeId;

    }

    if(!variantId){

        alert("Variant not found.");
        return;

    }

    card.querySelector(".variant-id-input").value = variantId;

    card.querySelector(".car-brand-input").value =
        currentVehicle.brand;

    card.querySelector(".car-model-input").value =
        currentVehicle.model;

    card.querySelector(".car-size-input").value =
        currentCarSize;

    const form = card.querySelector("form");

    form.requestSubmit();

}
async function refreshCartDrawer(){

    const drawer = document.querySelector("cart-drawer");

    if(!drawer) return;

    try{

        await drawer.reload();

    }catch(e){

        console.log(e);

    }

}
async function openCartDrawer() {

    const response = await fetch("/?sections=cart-drawer,cart-icon-bubble");

    const sections = await response.json();

    // Update Drawer HTML
    const drawerSection = document.getElementById("shopify-section-cart-drawer");

    if (drawerSection) {
        drawerSection.innerHTML = sections["cart-drawer"];
    }

    // Update Cart Bubble
    const bubbleSection = document.getElementById("shopify-section-cart-icon-bubble");

    if (bubbleSection) {
        bubbleSection.innerHTML = sections["cart-icon-bubble"];
    }

    // Wait DOM update
    await new Promise(resolve => setTimeout(resolve, 50));

    // New drawer element
    const drawer = document.querySelector("cart-drawer");

    if (!drawer) {
        console.error("Cart Drawer not found.");    
        return;
    }

    // Open drawer
    drawer.classList.remove("is-empty");
    drawer.classList.add("active");

    document.body.classList.add("overflow-hidden");

    const overlay = drawer.querySelector(".cart-drawer__overlay");

    if (overlay) {
        overlay.addEventListener("click", () => {
            drawer.classList.remove("active");
            document.body.classList.remove("overflow-hidden");
        });
    }

}
async function checkCartServices(){

    const cart = await fetch("/cart.js")
        .then(r=>r.json());

    document.querySelectorAll(".service-card").forEach(card=>{

        let variant="";

        if(currentCarSize.toLowerCase()=="small"){

            variant=card.dataset.smallId;

        }
        else if(currentCarSize.toLowerCase()=="medium"){

            variant=card.dataset.mediumId;

        }
        else{

            variant=card.dataset.largeId;

        }

        const exists = cart.items.some(
            item=>Number(item.id)==Number(variant)
        );

        const btn = card.querySelector(".add-service-btn");

        const span = btn.querySelector("span");

        if(exists){

            btn.disabled = true;

            btn.classList.add("added");

            if(span)
                span.textContent = "Already Added";

        }
        else{

            btn.disabled = false;

            btn.classList.remove("added");

            if(span)
                span.textContent = "Add Service";

        }

    });

}
function buildFilters(){

    const cards = document.querySelectorAll(".service-card");

    const categories = new Set();
    const durations = new Set();

    cards.forEach(card=>{

        if(card.dataset.category)
            categories.add(card.dataset.category);

        if(card.dataset.duration)
            durations.add(card.dataset.duration);

    });

    const categoryBox=document.getElementById("categoryFilters");
    categoryBox.innerHTML="";

    [...categories].sort().forEach(cat=>{

        categoryBox.insertAdjacentHTML(
            "beforeend",
            `
            <label class="filter-option">
                <input
                    type="checkbox"
                    class="category-filter"
                    value="${cat}">
                ${cat}
            </label>
            `
        );

    });

    const durationBox=document.getElementById("durationFilters");
    durationBox.innerHTML="";

    [...durations].sort().forEach(duration=>{

        durationBox.insertAdjacentHTML(
            "beforeend",
            `
            <label class="filter-option">
                <input
                    type="checkbox"
                    class="duration-filter"
                    value="${duration}">
                ${duration}
            </label>
            `
        );

    });

}
function bindFilters(){

    document
    .getElementById("serviceSearch")
    .addEventListener("keyup",filterServices);

    document.addEventListener("change",function(e){

        if(
            e.target.classList.contains("category-filter") ||
            e.target.classList.contains("duration-filter")
        ){

            filterServices();

        }

    });

}
function filterServices(){

    const keyword=document
        .getElementById("serviceSearch")
        .value
        .toLowerCase()
        .trim();

    const categories=[
        ...document.querySelectorAll(".category-filter:checked")
    ].map(x=>x.value);

    const durations=[
        ...document.querySelectorAll(".duration-filter:checked")
    ].map(x=>x.value);

    document.querySelectorAll(".service-card").forEach(card=>{

        const title=(card.dataset.title || "").toLowerCase();
        const category=card.dataset.category || "";
        const duration=card.dataset.duration || "";

        const matchSearch=
            keyword==="" ||
            title.includes(keyword);

        const matchCategory=
            categories.length===0 ||
            categories.includes(category);

        const matchDuration=
            durations.length===0 ||
            durations.includes(duration);

        card.style.display=
            matchSearch &&
            matchCategory &&
            matchDuration
            ? ""
            : "none";

    });

}